import { IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { Query } from 'utility-ts-orm';
import { RegistrationOneClickModel } from '../models/registration_one_click_model';
import { RegisterSectionsQuery } from '../../course_scheduler/queries/register_sections_query';
import { IRegisterSectionsDatasource } from '../../course_scheduler/datasources/register_sections_datasource';

interface IRegistrationOneClickQueryResult {
  isOneClickRegistrationEnabled: boolean;
  showRegisterButton: boolean;
  selectedSectionsText: string;
}

export class RegistrationOneClickQuery implements IQuery {
  private _result: IRegistrationOneClickQueryResult;
  private isOneClickRegistrationEnabled: boolean = false;

  constructor(
    private schedulerConfigModel: any,
    private FEATURE_ONE_CLICK_REGISTRATION_NK: string,
    private ngSchedulerModel: any,
    private ngRegisterSectionsQuery: RegisterSectionsQuery,
    private ngRegisterSectionsDatasource: IRegisterSectionsDatasource
  ) {
    Query.registerQuery(this, schedulerConfigModel, ngSchedulerModel, ngRegisterSectionsDatasource);
  }

  shouldShowRegisterButton() {
    return !this.isOneClickRegistrationEnabled ? true : _4.get(this.ngSchedulerModel.read(), 'precheck_pass', false);
  }

  run() {
    this.isOneClickRegistrationEnabled = this.schedulerConfigModel.isFeatureEnabled(
      this.FEATURE_ONE_CLICK_REGISTRATION_NK
    );
    this._result = {
      isOneClickRegistrationEnabled: this.isOneClickRegistrationEnabled,
      showRegisterButton: this.shouldShowRegisterButton(),
      selectedSectionsText: `(${this.ngRegisterSectionsQuery.result.selectedSections.length})`
    };
    return this;
  }

  get result() {
    return this._result;
  }
}

angular.module('capability-ng-scheduler').service('ngRegistrationOneClickQuery', RegistrationOneClickQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/registration/queries/registration_one_click_query.ts